import { RouteWrapper } from '../../component';
import MatchMakingWinnerMWeb from '../../component/match_making_winner/index_mWeb';
import ScreenBackgroundWrapper from '../../component/screen_background_wrapper';
import constants from '../../constants';
import useWindowOrientation from '../../utilities/hooks/useWindowOrientation';
import './index_mWeb.css';
import MatchMakingResultWeb from './index_web';

interface Props {
  winnerData?: any;
  avatars?: any;
  onPressPlayAgain?: any;
  onPressGoBack?: any;
  isShowScore?: boolean;
}

const MatchMakingResultMWeb = ({
  winnerData = {},
  avatars = {},
  onPressPlayAgain,
  onPressGoBack,
  isShowScore = false
}: Props) => {
  const { myWinnerUser = {}, opponentWinnerUser = {} } = winnerData;
  const {
    avatarId: myAvatarId = 0,
    score: myScore = 0,
    winner: myWinner = false,
    winning: myWinning = 0,
    winningType: myWinningType = 1
    // username: myUsername = ''
  } = myWinnerUser;
  const {
    avatarId: opponentAvatarId = 0,
    score: opponentScore = 0,
    winner: opponentWinner = false,
    username: opponentUsername = '',
    winning: opponentWinning = 0,
    winningType: opponentWinningType = 1
  } = opponentWinnerUser;

  const { isLandscape } = useWindowOrientation();

  if (isLandscape) {
    return (
      <MatchMakingResultWeb
        winnerData={winnerData}
        avatars={avatars}
        onPressGoBack={onPressGoBack}
        onPressPlayAgain={onPressPlayAgain}
        isLandscape={isLandscape}
      />
    );
  }

  return (
    <RouteWrapper>
      <ScreenBackgroundWrapper>
        <div className="matchMakingResult__mainContainer__mWeb">
          <div className={'matchMakingResult__avatarMainContainer__mWeb'}>
            <MatchMakingWinnerMWeb
              avatar={avatars[myAvatarId]}
              score={myScore}
              winner={myWinner}
              winnings={myWinning}
              winningType={myWinningType}
              username={'You'}
              isShowScore={isShowScore}
            />
            <div className={'matchMakingResult__vsContainer__mWeb '}>
              <img
                className={'matchMakingResult__vsImg__mWeb '}
                src={constants.Images.MatchMakingVs}
              />
            </div>
            <MatchMakingWinnerMWeb
              avatar={avatars[opponentAvatarId]}
              score={opponentScore}
              winner={opponentWinner}
              winnings={opponentWinning}
              winningType={opponentWinningType}
              username={opponentUsername}
              isShowScore={isShowScore}
            />
          </div>
          <div className="matchMakingResult__bottomContainer__mWeb">
            <button className="matchMakingResult__playAgainBtn__mWeb" onClick={onPressPlayAgain}>
              {'play again'}
            </button>
            <button className="matchMakingResult__goBackBtn__mWeb" onClick={onPressGoBack}>
              {'go back'}
            </button>
          </div>
        </div>
      </ScreenBackgroundWrapper>
    </RouteWrapper>
  );
};

export default MatchMakingResultMWeb;
